module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.row.name))]), _vm._v(" "), _c('van-dropdown-menu', [_c('van-dropdown-item', {
    attrs: {
      "options": _vm.options
    },
    on: {
      "change": _vm.subjectChange
    },
    model: {
      value: (_vm.params.subject),
      callback: function($$v) {
        _vm.$set(_vm.params, "subject", $$v)
      },
      expression: "params.subject"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "2.3rem"
    }
  }), _vm._v(" "), _vm._l((_vm.list), function(subjectGroup, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subjectGroup.list.length > 0),
        expression: "subjectGroup.list.length>0"
      }],
      key: i,
      staticClass: "activity-list"
    }, [_c('div', {
      staticClass: "activity-list-title-box"
    }, [_c('div', {
      staticClass: "title-left-solid"
    }), _vm._v(" "), _c('div', {
      staticClass: "activity-title"
    }, [_vm._v(_vm._s(subjectGroup.sub_subject_name))])]), _vm._v(" "), _c('div', {
      staticClass: "list-team"
    }, [_vm._l((subjectGroup.list), function(item, i2) {
      return _c('div', {
        key: i2,
        staticClass: "team-item"
      }, [_c('div', {
        staticClass: "team-rank"
      }, [((item.rank - 1) < 3) ? _c('div', {
        class: 'team-rank-num rank-change' + (item.rank - 1)
      }, [_vm._v(_vm._s(item.rank) + ".")]) : _c('div', {
        staticClass: "team-rank-num rank-no"
      }, [_vm._v(_vm._s(i2 + 1))])]), _vm._v(" "), _c('div', {
        staticClass: "team-info"
      }, [_c('div', {
        staticClass: "team-info-name"
      }, [_vm._v(_vm._s(item.mingcheng))]), _vm._v(" "), _c('div', {
        staticClass: "team-info-grande"
      }, [_c('em', [_vm._v(_vm._s(item.score_total))]), _vm._v("分")])])])
    }), _vm._v(" "), _c('div')], 2)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356b94ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiResult.vue
// module id = 1407
// module chunks = 0